import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, Validators, Form, FormGroup } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import { NavigationService } from "src/app/services/navigation.service";
import { ProductService } from "src/app/services/product.service";
import { Location } from "@angular/common";
import { ManufacturerService } from "src/app/services/manufacturer.service";
import { AlertService } from "src/app/services/alert.service";

@Component({
  selector: "app-manufacturerLockpopup",
  templateUrl: "./manufacturerLockpopup.component.html",
  styleUrls: ["./manufacturerLockpopup.component.scss"]
})
export class ManufacturerLockPopupComponent implements OnInit {
  showNotes: boolean = true;
  id: any;
  priceLockStatusType: any;
  form: FormGroup;
  dataArrayType: any[];
  authorized: boolean = false;
  balance: boolean = false;
  corporate: boolean = false;
  msme: boolean = false;
  Pricerelated: boolean = false;
  TestValidity: boolean = false;
  TestCenterName: boolean = false;
  TestCertificateUpload: boolean = false;
  remarkdisable: boolean;
  msmeother: boolean = false;
  balancesheet: boolean = false;
  corporatecontact: boolean = false;
  authorizedcontact: boolean = false;
  dataArraysType: any[];

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private manufacturerService: ManufacturerService,
    private alertService: AlertService,

    private _location: Location,

    public dialogRef: MatDialogRef<ManufacturerLockPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,

    public addServiceDialog: MatDialog,
    private navigationService: NavigationService
  ) {
    this.id = this.dataRecievedToEdit.id;
    this.priceLockStatusType = this.dataRecievedToEdit.priceLockStatusType;
  }

  ngOnInit(): void {
    this.showNotes = true;
    this.initializeValidators();
    if(this.priceLockStatusType==3){
      this.get();
    }else if(this.priceLockStatusType==4){   
    this.getproduct();
    }
    this.remarkdisable=true;
    
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      remarks: [""]
    });
  }

  get() {
    this.manufacturerService
      .getManufacturerEditType(this.id, true)
      .subscribe(res => {
        this.dataArrayType = JSON.parse(res.manufacturerEditType);
        this.dataArrayType.forEach(element => {
          if (element == 1) {
            this.corporate = true;
          }
          if (element == 2) {
            this.authorized = true;
          }
          if (element == 3) {
            this.balance = true;
          }
          if (element == 4) {
            this.msme = true;
          }
        });
        this.form.controls["remarks"].setValue(res.remarks);
       
      });
  } 
  getproduct() {
    this.manufacturerService
      .getproductclarificationType(this.id, true)
      .subscribe(res => {
        this.dataArraysType = JSON.parse(res.productEditType);
        this.dataArraysType.forEach(element => {
          if (element == 1) {
            this.Pricerelated = true;
          }
          if (element == 2) {
            this.TestValidity = true;
          }
          if (element == 3) {
            this.TestCenterName = true;
          }
          if (element == 4) {
            this.TestCertificateUpload = true;
          }
        });
        this.form.controls["remarks"].setValue(res.remarks);
       
      });
  }

  next() {
    this.dialogRef.close();
  }

  goToAction(item: number) {
    var data = {
      id: this.id,
      priceLockStatusType: this.priceLockStatusType,
      remarks: this.form.value.remarks,
      financialYearId:this.dataRecievedToEdit.financialYearId
    };
    // this.manufacturerService.manufacturerLock(data).subscribe(res => {
    //   if (res && res.isSuccess) {
    //     if (this.priceLockStatusType == 1)
    //       this.alertService.success('Locked for Committee Review Successfully');
    //     else
    //       this.alertService.success('Release for Price Successfully');
    //     this.dialogRef.close(true);

    //   }
    //   else {
    //     this.alertService.error(res.htmlFormattedFailures);
    //   }
    // });

    this.productService.productLock(data).subscribe(res => {
      if (res && res.isSuccess) {
        if (this.priceLockStatusType == 1)
          this.alertService.success("Locked for Committee Review Successfully");
        else this.alertService.success("Release for Price Successfully");
        this.dialogRef.close();
      } else {
        this.alertService.error(res.htmlFormattedFailures);
      }
    });
  }
}
